import { render } from "./publish-changes.vue?vue&type=template&id=1eaaf4e7&lang=pug"
import script from "./publish-changes.vue?vue&type=script&setup=true&lang=js"
export * from "./publish-changes.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__